module.exports = __webpack_public_path__ + "media/images/footer_x-5ad7666d04b3c92604fa05e88ffa1906.svg";